import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCog } from 'react-icons/fa';
import { CampaignContractType } from '../../../../../../enum/CampaignContractType';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';
import { InternalRoutes } from '../../../../../../enum/InternalRoutes';
import CardLayout from '../../../../../../shared/components/card/CardLayout';

export interface IContractTypeCardProps {
    contractType?: string;
    openEditCampaignModal?: (editContractType?: boolean) => void;
    isCampaignDeleted?: boolean;
    hasSuppliers?: boolean;
    hasClients?: boolean;
    longTermId?: number;
}

export function ContractTypeCard({
    contractType,
    openEditCampaignModal,
    isCampaignDeleted,
    longTermId,
}: IContractTypeCardProps) {
    const { t } = useTranslation();
    const canDoLongTerm = useSelector((state: IAllStates) => state.auth?.user?.company?.package?.canDoLongTerm);
    const hasClients = useSelector((state: IAllStates) => state.auth?.user?.hasClients);
    const hasSuppliers = useSelector((state: IAllStates) => state.auth?.user?.hasSuppliers);
    const isGeneralClient = useSelector((state: IAllStates) => state.auth?.user?.isGeneralClient);

    const isStandardCampaign = contractType === CampaignContractType.STANDARD_CAMPAIGN;

    const canEdit = (canDoLongTerm || hasSuppliers || hasClients) && !isGeneralClient;
    const showEditIcon = isStandardCampaign && canEdit;

    return (
        <CardLayout>
            <div className="d-flex justify-content-between ">
                <h5 className="mb-3">{t('brand.campaign.briefing.contract_type.contract_type')}</h5>
                {showEditIcon && (
                    <FaCog
                        className="cursor-pointer"
                        style={{ right: 0 }}
                        id="edit-icon"
                        name="modal"
                        onClick={() => openEditCampaignModal && !isCampaignDeleted && openEditCampaignModal(true)}
                    />
                )}
            </div>
            <Row>
                <Col md={4} className="d-flex align-items-center justify-content-center">
                    <div className="text-center">
                        <i className={`fi fi-rr-building text-primary h1`} />
                        <h6>{t(`brand.campaign.briefing.contract_type.${contractType}.contractType`)}</h6>
                    </div>
                </Col>
                <Col md={8} className="d-flex align-items-center">
                    <div className="py-2">
                        <h5 className="font-weight-bold">
                            {t(`brand.campaign.briefing.contract_type.${contractType}.title`)}
                        </h5>
                        <p
                            className="text-muted mb-0"
                            dangerouslySetInnerHTML={{
                                __html: t(`brand.campaign.briefing.contract_type.${contractType}.description`, {
                                    longTermLink: `${InternalRoutes.BRAND_CAMPAIGN_CREATE}/${longTermId}/overview`,
                                }),
                            }}
                        ></p>
                    </div>
                </Col>
            </Row>
        </CardLayout>
    );
}
